<template>
  <div class="container">
    <!-- <van-sticky>
      <van-search
        v-model="couponCode"
        placeholder="请输入商品条码"
        @search="searchCouponByCode"
        show-action
      >
        <template #action>
          <van-button
            type="info"
            icon="search"
            size="small"
            @click="searchCouponByCode"
            >搜索</van-button
          >
        </template>
      </van-search>
    </van-sticky>-->
    <van-tabs
      @click="selectByStatus"
      title-active-color="#C99B54"
      color="#c99b54"
      v-model="orderStatus"
    >
      <van-tab
        v-for="(child, idx) in tabs"
        v-bind:key="idx"
        :title="child.name"
        :name="child.title"
        style="padding:0 8px 8px 8px;"
      >
        <div class="sort" v-if="child.status !== 2">
          <div
            v-if="
              child.status == 0 || (child.status == 1 && couponList.length > 0)
            "
            class="sort-item"
            @click="changeSort"
          >
            {{ tabs[idx].sort }}
            <span class="sort_icon" v-if="sort == 'ASC'">
              <div class="top_arrows_active"></div>
              <div class="bottom_arrows"></div>
            </span>
            <span class="sort_icon" v-else>
              <div class="top_arrows"></div>
              <div class="bottom_arrows_active"></div>
            </span>
          </div>
          <!-- 占位 -->
          <div v-else></div>
          <van-icon
            v-if="
              child.status == 0 && couponList.length > 0
            "
            name="apps-o"
            style="float:right"
            @click="toBatchOper"
          >批量操作</van-icon>
          <div v-if="child.status == 1" @click="changeShowActiveStatus">
            {{ activeStatus.text }}
            <van-icon style="margin-left:4px" name="arrow-down"></van-icon>
          </div>
          <div v-if="child.status == 3" @click="changeShowExpiredStatus">
            {{ expiredStatus.text }}
            <van-icon style="margin-left:4px" name="arrow-down"></van-icon>
          </div>
        </div>
        <van-pull-refresh
          v-model="refreshing"
          @refresh="onRefresh"
          :style="
            (couponList.length > 0 ? 'min-height: 100vh;' : '') +
            (child.status !== 2 && couponList.length > 0
              ? 'padding-top:2.02898rem;'
              : 'padding-top:1.0628rem;')
          "
        >
          <van-list
            v-if="couponList.length > 0"
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            offset="100"
            @load="loadData"
          >
            <div
              class="item"
              v-for="(item, index) in couponList"
              v-bind:key="index"
              :style="child.status == 2 ? 'margin-top:8px' : ''"
            >
              <div class="top">
                <van-image width="60" height="60" :src="item.productPicture"></van-image>
                <div class="top-content">
                  <div class="code">
                    <div class="code-title">编码</div>
                    <div class="code-value">{{ item.couponCode }}</div>
                  </div>
                  <div class="good-name">{{ item.designatedGoods }}</div>
                </div>
              </div>
              <div class="bottom">
                <div class="time">{{ item.startTime }}~{{ item.endTime }}</div>
                <div class="bottom-btn">
                  <van-button
                    v-if="
                      child.status === 1 &&
                      item.couponStatus === '2' &&
                      item.soFar <= 7
                    "
                    plain
                    class="list-item-button"
                    color="#c6a560"
                    @click="onSelect(item)"
                  >退款</van-button>
                  <van-button
                    color="#c6a560"
                    plain
                    class="list-item-button"
                    @click="
                      orderStatus === '2'
                        ? toCouponAfterSale(item)
                        : toCouponDetail(item)
                    "
                    style="margin-left:10px"
                  >查看</van-button>
                  <van-button
                    v-if="child.status === 0"
                    color="#C59A56"
                    class="list-item-button"
                    style="margin-left:12px"
                    @click="toActivateCoupon(item)"
                  >激活</van-button>
                </div>
              </div>
            </div>
          </van-list>
          <van-empty v-else description="没有提货卡"></van-empty>
        </van-pull-refresh>
        <van-popup
          v-model="showActiveStatus"
          closeable
          position="bottom"
          close-icon-position="top-left"
          style="height:30%;display: flex;flex-direction: column"
          v-if="child.status == 1 && showActiveStatus === true"
          transition-appear
        >
          <div class="title">筛选卡片状态</div>
          <div class="content">
            <van-button
              v-for="(text, i) in allActiveStatus"
              v-bind:key="i"
              style="width:96px;height:30px"
              @click="changeActiveStatus(text)"
              :color="activeStatus.value === text.value ? '#c6a560' : ''"
            >{{ text.text }}</van-button>
          </div>
        </van-popup>
        <van-popup
          v-model="showExpiredStatus"
          closeable
          position="bottom"
          close-icon-position="top-left"
          style="height:30%;display: flex;flex-direction: column"
          v-if="child.status == 3 && showExpiredStatus === true"
          transition-appear
        >
          <div class="title">筛选卡片状态</div>
          <div class="content">
            <van-button
              v-for="(text, i) in allExpiredStatus"
              v-bind:key="i"
              style="width:106px;height:30px"
              @click="changeExpiredStatus(text)"
              :color="expiredStatus.value === text.value ? '#c6a560' : ''"
            >{{ text.text }}</van-button>
          </div>
        </van-popup>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { apiPost } from "@/api/common";
import {
  formatMomentOther,
  formatDateMoment,
  relativeMomentNumber
} from "@/utils/date-time.js";
import { Toast } from "vant";
export default {
  data() {
    return {
      shopInfo: "",
      orderStatus: "0",
      tabs: [
        {
          status: 0,
          name: "待激活",
          title: "0",
          sort: "到期时间"
        },
        {
          name: "已激活",
          status: 1,
          title: "1",
          sort: "激活时间"
        },
        {
          name: "已过期",
          status: 3,
          title: "3"
        },
        {
          name: "退款审核中",
          status: 2,
          title: "2"
        }
      ],
      activeStatus: { value: "", text: "全部" },
      expiredStatus: { value: "", text: "全部" },
      allActiveStatus: [
        { value: "", text: "全部" },
        { value: "3", text: "已兑换" },
        { value: "2", text: "未兑换" }
      ],
      allExpiredStatus: [
        { value: "", text: "全部" },
        { value: "2", text: "已激活未兑换" },
        { value: "1", text: "待激活" }
      ],
      refreshing: false,
      loading: true,
      finished: false,
      sort: "ASC",
      couponList: [],
      showPopoverFlag: [[], [], [], []],
      actions: [{ text: "客户退款" }],
      showActiveStatus: false,
      showExpiredStatus: false,
      pageNum: 1,
      total: 0,
      couponCode: ""
    };
  },
  created() {
    // alert("is ios:" + browser.versions.ios);
    // alert("is android:" + browser.versions.android);
    // this.$toast.fail("is ios:" + browser.versions.ios);
    // this.$toast.fail("is android:" + browser.versions.android);
    if (
      window.sessionStorage.getItem("couponListStatus") !== null &&
      window.sessionStorage.getItem("couponListStatus") !== ""
    ) {
      this.orderStatus = window.sessionStorage.getItem("couponListStatus");
    } else {
      this.orderStatus = "0";
    }
    this.loadComments();
    this.getCouponList();
    this.couponList = [];
  },
  methods: {
    searchCouponByCode() {
      this.couponList = [];
      this.pageNum = 1;
      this.getCouponList();
    },
    onRefresh() {
      this.couponList = [];
      this.pageNum = 1;
      this.finished = false;
      this.loading = true;
      this.loadData();
    },
    loadComments() {
      let s = sessionStorage.getItem("shopInfo");
      this.shopInfo = s ? JSON.parse(s) : "";
    },
    changeSort() {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      if (this.sort == "ASC") {
        this.sort = "DESC";
      } else {
        this.sort = "ASC";
      }
      this.total = 0;
      this.pageNum = 1;
      this.getCouponList();
      this.couponList = [];
      this.finished = false;
    },
    selectByStatus(title) {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      this.total = 0;
      this.pageNum = 1;
      window.sessionStorage.setItem("couponListStatus", title);
      this.orderStatus = window.sessionStorage.getItem("couponListStatus");
      this.showActiveStatus = false;
      this.getCouponList();
      this.couponList = [];
      this.finished = false;
    },
    getCouponList() {
      let url = "/order/couponBusiness/queryCouponList";
      let data = {
        storeId: this.shopInfo.shopCode,
        sort: this.sort,
        pageSize: 10,
        pageNum: this.pageNum,
        couponCode: this.couponCode
      };
      if (this.orderStatus === "1" && this.activeStatus !== "") {
        let cardStatus = this.activeStatus.value;
        data.cardStatus = cardStatus;
      }
      if (this.orderStatus === "3" && this.expiredStatus !== "") {
        let cardStatus = this.expiredStatus.value;
        data.cardStatus = cardStatus;
      }
      if (this.orderStatus) {
        data.status = this.orderStatus;
      }
      apiPost(url, data).then(res => {
        if (res.data.code == "0000") {
          this.showPopoverFlag = [[], [], [], []];
          let couponList = res.data.data.results.records;
          if (res.data.data.results.total !== 0) {
            this.total = res.data.data.results.total;
          }
          for (let [index, item] of couponList.entries()) {
            if (item.activationTime) {
              item.soFar = relativeMomentNumber(item.activationTime);
              item.activationTime = formatDateMoment(item.activationTime);
            }
            if (item.useTime) {
              item.useTime = formatDateMoment(item.useTime);
            }
            item.startTime=formatMomentOther(item.startTime);
            item.endTime=formatMomentOther(item.endTime);
            this.showPopoverFlag[parseInt(this.orderStatus)][index] = false;
          }
          this.couponList.push(...couponList);
        }
        this.loading = false;
        Toast.clear();
      });
    },
    //两个时间相差天数 兼容firefox chrome
    datedifference(date) {
      var dateTime = Date.parse(date);
      var nowDate = Date.parse(new Date().toLocaleString());
      console.log(nowDate);
      var dateSpan = nowDate - dateTime;
      dateSpan = Math.abs(dateSpan);
      var iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
      return iDays;
    },
    loadData() {
      var that = this;
      that.loading = true;
      if (that.refreshing) {
        that.refreshing = false;
      }
      if (that.couponList.length >= that.total) {
        that.finished = true;
        that.pageNum = 1;
      } else {
        that.getCouponList();
        that.pageNum = that.pageNum + 1;
        that.finished = false;
      }
    },
    changeShowActiveStatus() {
      this.showActiveStatus = !this.showActiveStatus;
    },
    changeShowExpiredStatus() {
      this.showExpiredStatus = !this.showExpiredStatus;
    },
    changeActiveStatus(status) {
      this.activeStatus = status;
      this.total = 0;
      this.pageNum = 1;
      this.getCouponList();
      this.couponList = [];
      this.finished = false;
      this.changeShowActiveStatus();
    },
    changeExpiredStatus(status) {
      this.expiredStatus = status;
      this.total = 0;
      this.pageNum = 1;
      this.getCouponList();
      this.couponList = [];
      this.finished = false;
      this.changeShowExpiredStatus();
    },
    toCouponDetail(obj) {
      obj.status = this.orderStatus;
      this.$router.push({ path: "/couponDetail", query: obj });
    },
    toCouponAfterSale(obj) {
      this.$router.push({ path: "/couponAfterSale", query: obj });
    },
    //前往激活提货卡
    toActivateCoupon(obj) {
      let params = {
        coupons: [obj]
      };
      this.$router.push({ path: "/activateCoupon", query: params });
    },
    //气泡弹出框选择
    onSelect(obj) {
      this.$router.push({ path: "/couponRefund", query: obj });
    },
    toBatchOper: function () {
      this.$router.push({ path: "/batchActivate" });
    }
  }
};
</script>

<style scoped lang="less">
.container {
  /deep/ .van-tabs__wrap {
    position: fixed;
    width: 100%;
    z-index: 1;
  }
  .sort {
    padding: 0 16px;
    box-sizing: border-box;
    margin-top: 1.0628rem;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #1d1d1d;
    line-height: 22px;
    height: 40px;
    line-height: 40px;
    position: fixed;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    right: 0;
    z-index: 99;
    background-color: #f7f7f7;
  }
  .item {
    position: relative;
    margin-bottom: 8px;
    height: 144px;
    width: 100%;
    background: url(https://imgs.youchalian.com/1634526918005.png) no-repeat;
    background-size: 100% 100%;
    padding: 16px 16px 16px 16px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .top {
      display: flex;
      flex-direction: row;
      .top-content {
        display: flex;
        flex-direction: column;
        margin-left: 10px;
        .code {
          display: flex;
          flex-direction: row;
          .code-title {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
          }
          .code-value {
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #8b572a;
            margin-left: 8px;
          }
        }
        .good-name {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          margin-top: 8px;
        }
      }
    }
    .bottom {
      box-sizing: border-box;
      width: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      vertical-align: bottom;
      .time {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        display: flex;
        align-items: center;
        height: 100%;
      }
      .bottom-btn {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        .van-popover__wrapper {
          display: flex;
        }
      }
    }
  }
}
.list-item-button {
  width: 80px;
  height: 26px;
  border-radius: 2px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.cell-value {
  text-align: left;
  margin-left: 16px;
}
.title {
  height: 53px;
  text-align: center;
  line-height: 53px;
  font-size: 14px;
  font-family: PingFangSC-semiBold;
  border-bottom: 1px solid #bbb;
}
.content {
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: row;
}
.top_arrows {
  width: 0;
  height: 0;
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
  border-bottom: 5px solid #ccc;
  margin: 3px;
}
.top_arrows_active {
  width: 0;
  height: 0;
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
  border-bottom: 5px solid rgb(197, 154, 86);
  margin: 3px;
}

.bottom_arrows {
  width: 0;
  height: 0;
  margin: 3px;
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
  border-top: 5px solid #ccc;
}

.bottom_arrows_active {
  width: 0;
  height: 0;
  margin: 3px;
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
  border-top: 5px solid rgb(197, 154, 86);
}

.sort_icon {
  float: left;
}
.sort-item {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
